import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  captureEmailLinkClick,
  hasEmailLinkParameters,
} from '../../util/emailLinkTracking';

/**
 * Renders nothing. Fires `email_link_clicked` when the user lands on any
 * authenticated route via an email link (`?mail_source=email&...`).
 * Mounted in PrivateRoute so it persists across redirects such as /grid-view,
 * which rewrites the URL and would otherwise lose the mail_* parameters.
 */
const EmailLinkTracker = () => {
  const { search } = useLocation();
  const handledSearch = useRef<string | null>(null);

  useEffect(() => {
    if (!hasEmailLinkParameters(search) || handledSearch.current === search) return;
    handledSearch.current = search;
    void captureEmailLinkClick(search);
  }, [search]);

  return null;
};

export default EmailLinkTracker;
